export default "__VITE_ASSET__1656b50b__"